<template>
  <div class="batch-upload-dailog container-block col-block">
    <div class="title-container row-block default-shadow">
      <div class="row-block" :style="{ width: '35px' }"></div>
      <div
        class="title"
        v-html="'零售價格批次上傳'"
      ></div>
      <div class="row-block close-button" :style="{ width: '35px' }">
        <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')">
      </div>
    </div>
    <div class="batch-upload-container col-block">
      <customRowForm
        :init="batchUpload"
        :alerts="alerts"
        :forms="formOptions['field1']"
        @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
      ></customRowForm>
      <div class="example-container row-block">
        <div :style="{ width: '125px' }"></div>
        <div class="example-title" @click="e => downloadExample()">範例excel下載</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <customRowForm
        :init="batchUpload"
        :alerts="alerts"
        :forms="formOptions['field2']"
        @change="() => {}"
      >
        <template slot="_FILES" slot-scope="props">
          <div :name="props" class="_FILES">
            <div class="file-container col-block">
              <div class="file-list col-block" :style="{ flex: 1 }">
                <div class="file-block row-block" v-for="(file, index) in files" :key="index">
                  <div :style="{ width: '5px' }"></div>
                  <a class="file-title" :title="file.name" :href="file.url" target="_blank">{{ file.name }}</a>
                  <div :style="{ width: '10px' }"></div>
                  <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeFile(file, 'files')">
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div :style="{ height: '5px' }"></div>
              <div class="mask">
                <label for="upload-file"></label>
                <input v-show="false" type="file" id="upload-file" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="e => fileTypeCheck(e, e => fileUpload(e, 'files'), () => addToast('error', '請上傳excel檔'))">
                <button class="main-button">
                  <span>選擇檔案</span>
                </button>
              </div>
              <div class="file-alert" v-if="alerts['_FILES'] && alerts['_FILES'].type === 'error'">{{ alerts['_FILES'].msg }}</div>
            </div>
          </div>
        </template>
        <template slot="_IMAGES" slot-scope="props">
          <div :name="props" class="_IMAGES">
            <div class="file-container col-block">
              <div class="file-list col-block" :style="{ flex: 1 }">
                <div class="file-block row-block" v-for="(file, index) in images" :key="index">
                  <div :style="{ width: '5px' }"></div>
                  <a class="file-title" :title="file.name" :href="file.url" target="_blank">{{ file.name }}</a>
                  <div :style="{ width: '10px' }"></div>
                  <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeFile(file, 'images')">
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div :style="{ height: '5px' }"></div>
              <div class="mask">
                <label for="upload-image"></label>
                <input v-show="false" type="file" id="upload-image" accept="application/zip,application/x-zip-compressed" @change="e => fileTypeCheck(e, e => fileUpload(e, 'images'), () => addToast('error', '請上傳zip檔'))">
                <button class="main-button">
                  <span>選擇檔案</span>
                </button>
              </div>
              <div class="file-alert" v-if="alerts['_IMAGES'] && alerts['_IMAGES'].type === 'error'">{{ alerts['_IMAGES'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <div :style="{ height: '10px' }"></div>
      <div class="button-container row-block">
        <div :style="{ flex: 1 }"></div>
        <button type="button" name="button" class="gray-button" @click="e => $emit('changeModal')">
          <span>取消</span>
        </button>
        <div :style="{ width: '20px' }"></div>
        <button type="button" name="button" class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validateBatchUploadFile()">
          <span>批次上傳</span>
        </button>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { API_ROOT } from '../../api/config'
import { postAdminProductPriceBatchUpload } from '../../api'
import customRowForm from '../../components/tool/customRowForm'
import toastMethods from '../../mixins/toastMethods'
import { downloadFile, fileTypeCheck } from '../../constants/global/util'

export default {
  components: {
    customRowForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      batchUpload: {
        market_country: '',
        // custom
        _FILES: '',
        _IMAGES: ''
      },
      // files
      files: [],
      images: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: '市場所在國家',
            value: 'market_country',
            type: 'datalist',
            lists: this.countryOptions.map(option => option.title),
            onChange: value => {
              if (value && !this.countryOptions.some(option => option.title === value)) {
                this.batchUpload = {
                  ...this.batchUpload,
                  ...this.result,
                  market_country: ''
                }
              }
            },
            placeholder: () => '請選擇國家',
            validate: 'required'
          },
          {
            title: '　'
          }
        ],
        field2: [
          {
            title: '批次檔案excel',
            value: '_FILES',
            validate: 'required'
          },
          {
            title: '零售價格照片ZIP',
            value: '_IMAGES',
            validate: 'required'
          }
        ]
      }
    },
    // global
    fileTypeCheck () { return fileTypeCheck }
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setUploadingAction'
    ]),
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
        _FILES: value => {
          if (!this.files.length) {
            return {
              type: 'error',
              msg: '此為必填欄位，請上傳 批次檔案excel'
            }
          }
        },
        _IMAGES: value => {
          if (!this.images.length) {
            return {
              type: 'error',
              msg: '此為必填欄位，請上傳 零售價格照片ZIP'
            }
          }
        }
      }
      for (let col of cols || Object.keys(this.batchUpload)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async fileUpload (e, value) {
      let files = Array.from(e.target.files)
      e.target.value = ''
      this[value] = [
        ...files
      ]
      // alert
      let alertKeyMap = {
        files: '_FILES',
        images: '_IMAGES'
      }
      this.alerts = {
        ...this.alerts,
        [alertKeyMap[value]]: null
      }
    },
    downloadExample () {
      let url = API_ROOT + 'public/product_prices/batch_upload_example.xlsx'
      downloadFile(null, url)
    },
    removeFile (file, value) {
      this[value].splice(this[value].indexOf(file), 1)
    },
    async validateBatchUploadFile () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.batchUploadFile()
      }
      this.onSubmit = false
    },
    async batchUploadFile () {
      this.setUploadingAction(null)
      try {
        let config = this.$ls.get('userInfo')
        let data = {
          ...this.result,
          market_country: (this.countryOptions.find(option => option.title === this.result.market_country) || {}).value,
          excel: this.files[0],
          images_zip: this.images[0]
        }
        let response = await postAdminProductPriceBatchUpload(data, config)
        this.addToast('success', response.data.result || '上傳成功')
        this.$emit('changeModal', {}, true)
        this.setUploadingAction()
      } catch (error) {
        this.setUploadingAction()
        let msg = !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>')
        // this.addToast('error', msg)
        this.$emit('changeModal', {
          action: 'toast',
          width: '720px',
          customStyles: {
            padding: '0px'
          },
          param: {
            type: 'error',
            content: '<span>' + msg + '</span>',
            buttons: [
              {
                title: '關閉',
                type: 'gray',
                icon: 'fa-repeat',
                style: {
                  padding: '10px 0',
                  width: '118px'
                },
                result: false
              }
            ]
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/batchUpload.vue